import React, { Component } from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import ReportFilterListItem from 'components/ReportFilterListItem/ReportFilterListItem';
import './RegionList.css';

class RegionList extends Component {
  static propTypes = {
    items: PropTypes.array,
    sort: PropTypes.object,
    onCheck: PropTypes.func,
    onSelect: PropTypes.func,
  }

  render() {
    const { items, sort } = this.props;
    var itemSorted = items;
    if (sort) {
      itemSorted = sort.direction === 'asc'
      ? (sortBy(items, sort.field))
      : (sortBy(items, sort.field).reverse());
    }
    return (
      <div className="region-list">
        {itemSorted.map((item, index) => (
          <ReportFilterListItem
            key={item.id}
            id={item.id}
            index={index}
            code={item.codeText}
            name={item.name}
            selected={item.selected}
            checked={item.checked}
            disabled={item.disabled}
            hasSelectedChildren={item.hasSelectedChildren}
            onSelect={this.props.onSelect}
            onCheck={this.props.onCheck}
          />
        ))}
      </div>
    );
  }
}

export default RegionList;
